import { isEmpty } from 'lodash';

import { UserNameDto, ContentProviderAccountDto } from 'api';
import { IdToken } from '@auth0/auth0-react';

export const getFullName = (fn?: string, ln?: string) => {
	return [fn, ln].filter(Boolean).join(' ');
};

export const getUserName = (userName: UserNameDto | undefined) => {
	if (!userName || isEmpty(userName)) return '';

	return `${userName.name}#${userName.suffix}`;
};

export const isInitialSetupCompleted = (user?: ContentProviderAccountDto) => {
	return user?.emailVerified && !isEmpty(user?.dateOfBirth);
};

export const termsAndConditionsAccepted = (
	user?: ContentProviderAccountDto,
) => {
	return user?.metadata?.termsAndConditions?.accepted === true;
};

export const isAdmin = (userClaims: IdToken | undefined) => {
	if (!userClaims) return false;
	const userRoles = Object.keys(userClaims)
		.filter((x) => x.endsWith('roles'))
		.map((x) => userClaims[x]);
	return !!userRoles[0].includes('Admin');
};
